import React, { Component } from "react";

class Project extends Component {
    render() {
        return (
            <div className="project-card">
                <div className="project-title">
                    {this.props.title}
                </div>

                <div className="project-content">
                    <div className="project-description">
                        {this.props.description}
                    </div>
                    <div className="project-linkrow">
                        <div className="project-button">
                            <a href={this.props.github} rel="noreferrer" target="_blank">View on GitHub</a>
                        </div>

                        {
                            this.props.demo ? 
                            <div className="project-button">
                                <a href={this.props.demo} rel="noreferrer" target="_blank">Demo</a>
                            </div> : 
                            <></>
                        }
                        {
                            this.props.read ? 
                            <div className="project-button">
                                <a href={this.props.read} rel="noreferrer" target="_blank">Read</a>
                            </div> : 
                            <></>
                        }
                    </div>
                </div>
            </div>
        )
    }
    
    
}
export default Project; 